import { Route, Routes } from "react-router-dom";
import ChangedPassword from "./changePassword";
import LoginForm from "./login";
import ResetPasswordForm from "./resetPassword";
import SignupForm from "./signup";



const Auth = (props) => {

    return (
        <Routes>
            <Route path="/" element={<LoginForm />} />
            <Route path="signup" element={<SignupForm />} />
            <Route path="reset-password" element={<ResetPasswordForm />} />
            <Route path="change-password" element={<ChangedPassword />} />
        </Routes>

    );
};

export default Auth;

